import { render, staticRenderFns } from "./PartsofBusinessIncluded.vue?vue&type=template&id=a1d07a10"
import script from "./PartsofBusinessIncluded.vue?vue&type=script&lang=js"
export * from "./PartsofBusinessIncluded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports